// extracted by mini-css-extract-plugin
module.exports = {"product-offer-drawer":"ProductOfferDrawer_product-offer-drawer__wtXq3"};